import i18next from 'i18next';
import * as yup from 'yup';

export const getEmailSchema = (): yup.StringSchema => yup.string().trim().email(i18next.t('validation.error.email'));
